var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-box-wrapper style1" }, [
    _c("div", { staticClass: "search-box" }, [
      _c("ul", { staticClass: "search-tabs clearfix" }, [
        _vm.modulo === "booking"
          ? _c("li", { staticClass: "active" }, [
              _c(
                "a",
                { attrs: { href: "#flights-tab", "data-toggle": "tab" } },
                [
                  _c("i", {
                    staticClass: "soap-icon-plane-right takeoff-effect",
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.searchboxflights[_vm.getCurrentLocale]) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "services"
          ? _c("li", { staticClass: "active" }, [
              _c(
                "a",
                { attrs: { href: "#flights-tab", "data-toggle": "tab" } },
                [
                  _c("i", {
                    staticClass: "soap-icon-plane-right takeoff-effect",
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.searchboxflights_services[_vm.getCurrentLocale]
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "rebooking"
          ? _c("li", { staticClass: "active" }, [
              _c(
                "a",
                { attrs: { href: "#rebooking-tab", "data-toggle": "tab" } },
                [
                  _c("i", {
                    staticClass: "soap-icon-plane-right takeoff-effect",
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.searchboxrebooking[_vm.getCurrentLocale]) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "flighttransfer"
          ? _c("li", { staticClass: "active" }, [
              _c(
                "a",
                {
                  attrs: { href: "#flighttransfer-tab", "data-toggle": "tab" },
                },
                [
                  _c("i", {
                    staticClass: "soap-icon-plane-right takeoff-effect",
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.searchboxflighttransfer[_vm.getCurrentLocale]
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "addinfant"
          ? _c("li", { staticClass: "active" }, [
              _c(
                "a",
                { attrs: { href: "#addinfant-tab", "data-toggle": "tab" } },
                [
                  _c("i", {
                    staticClass: "soap-icon-plane-right takeoff-effect",
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.searchboxaddinfant[_vm.getCurrentLocale]) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visible-mobile" }, [
        _c(
          "ul",
          {
            staticClass: "search-tabs clearfix",
            attrs: { id: "mobile-search-tabs" },
          },
          [
            _vm.modulo === "booking"
              ? _c("li", { staticClass: "active" }, [
                  _c("a", { attrs: { href: "#flights-tab" } }, [
                    _vm._v(_vm._s(_vm.searchboxflights[_vm.getCurrentLocale])),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "services"
              ? _c("li", { staticClass: "active" }, [
                  _c("a", { attrs: { href: "#flights-tab" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.searchboxflights_services[_vm.getCurrentLocale]
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "rebooking"
              ? _c("li", { staticClass: "active" }, [
                  _c("a", { attrs: { href: "#rebooking-tab" } }, [
                    _vm._v(
                      _vm._s(_vm.searchboxrebooking[_vm.getCurrentLocale])
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "flighttransfer"
              ? _c("li", { staticClass: "active" }, [
                  _c("a", { attrs: { href: "#flighttransfer-tab" } }, [
                    _vm._v(
                      _vm._s(_vm.searchboxflighttransfer[_vm.getCurrentLocale])
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "addinfant"
              ? _c("li", { staticClass: "active" }, [
                  _c("a", { attrs: { href: "#addinfant-tab" } }, [
                    _vm._v(
                      _vm._s(_vm.searchboxaddinfant[_vm.getCurrentLocale])
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search-tab-content" }, [
        _vm.modulo === "booking"
          ? _c(
              "div",
              {
                staticClass: "tab-pane fade active in",
                attrs: { id: "flights-tab" },
              },
              [
                _c("sdr-shared-flightsearch-tab", {
                  attrs: { modulo: _vm.modulo },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "services"
          ? _c(
              "div",
              {
                staticClass: "tab-pane fade active in",
                attrs: { id: "flights-tab" },
              },
              [
                _c("sdr-shared-flightsearch-tab", {
                  attrs: { modulo: _vm.modulo },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "rebooking"
          ? _c(
              "div",
              {
                staticClass: "tab-pane fade active in",
                attrs: { id: "rebooking-tab" },
              },
              [_c("sdr-shared-rebooking-tab")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "flighttransfer"
          ? _c(
              "div",
              {
                staticClass: "tab-pane fade active in",
                attrs: { id: "flighttransfer-tab" },
              },
              [_c("sdr-shared-flighttransfer-tab")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.modulo === "addinfant"
          ? _c(
              "div",
              {
                staticClass: "tab-pane fade active in",
                attrs: { id: "addinfant-tab" },
              },
              [_c("sdr-shared-addinfant-tab")],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }